module.exports = __webpack_public_path__ + "img/legend-title2.5acd55ca.png";